module.exports = __webpack_public_path__ + "media/images/certificado-7a7570d49ce793cfdad2d86f8ccc2fbc.png";